import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import ItemModify from '../Form/ItemModify';

@inject('folderStore')
@observer
class FolderModify extends Component {
   render() {
    const { folderStore, params } = this.props;
    return (
      <ItemModify
      title='Project'
      slug = '/folder'
      store = {folderStore}
      itemFields = {[
        { label: 'Id', key: 'id', type: 'text', readOnly:true, editOnly:true },
        { label: 'Name', key: 'name', type: 'text' },
        { label: 'Description', key: 'description', type: 'text' },
      ]}
      params={params}
      />
    );
  }
}

export default FolderModify;



// WEBPACK FOOTER //
// ./src/components/Folder/FolderModify.js